import { render } from "./CustomerQuote.vue?vue&type=template&id=04bc5fa8&scoped=true"
import script from "./CustomerQuote.vue?vue&type=script&lang=js"
export * from "./CustomerQuote.vue?vue&type=script&lang=js"

import "./CustomerQuote.vue?vue&type=style&index=0&id=04bc5fa8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04bc5fa8"]])

export default __exports__